import React from 'react'
import { Link } from 'react-router-dom'
import Prodect_1 from '../../../assets/images/home_page_2/product/01.png'
import Prodect_2 from '../../../assets/images/home_page_2/product/02.png'
import Prodect_3 from '../../../assets/images/home_page_2/product/03.png'

const Prodect = () => {
    return (
        <>
            <section id="products-two" className="products-two-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="products-two-block">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-img">
                                            <Link to="/Shop" title="">
                                                <img
                                                    src={Prodect_1}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-dtls">
                                            <h6 className="product-two-sub-title">Up to 40% off</h6>
                                            <h2 className="products-two-title cormorant-font">
                                                <Link to="/Shop" title="">
                                                    Ceramics Electric Jug
                                                </Link>
                                            </h2>
                                        </div>
                                        <div className="product-two-btn">
                                            <Link
                                                to="/Shop"
                                                className="btn btn-secondary-second float-start float-lg-end"
                                            >
                                                Shop now
                                                <i className="flaticon-right-arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="products-two-block products-two-block-one">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-img">
                                            <Link to="/Shop" title="">
                                                <img
                                                    src={Prodect_2}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-dtls">
                                            <h6 className="product-two-sub-title">Up to 40% off</h6>
                                            <h2 className="products-two-title cormorant-font">
                                                <Link to="/Shop" title="">
                                                    Ceramics Coffe cup
                                                </Link>
                                            </h2>
                                            <Link to="/Shop" className="btn btn-primary-second">
                                                Shop now
                                                <i className="flaticon-right-arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="products-two-block products-two-block-one">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-dtls">
                                            <h6 className="product-two-sub-title">Up to 40% off</h6>
                                            <h2 className="products-two-title cormorant-font">
                                                <Link to="/Shop" title="">
                                                    Ceramics Coffe cup
                                                </Link>
                                            </h2>
                                            <Link to="/Shop" className="btn btn-primary-second">
                                                Shop now
                                                <i className="flaticon-right-arrow" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="products-two-img">
                                            <Link to="/Shop" title="">
                                                <img
                                                    src={Prodect_3}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Prodect
